export enum CreatePasswordError {
  /** The server returns an undefined or internal error */
  UnknownError = 'UNKNOWN_ERROR',

  /** The token is expired */
  ExpiredToken = 'EXPIRED_TOKEN',

  /** The value for token is not correct */
  WrongToken = 'WRONG_TOKEN',
}
